import {SecureService} from "@/services/superclasses/secure-service";
import {BordasSubscription} from "@/interfaces/bordas-subscription";

const api = window.contextPath + '/rest/subscriber/bordas';

export class BordasSecureService extends SecureService {

    public loadSubscription = async (subscriptionId: string, hostId: number, state: number): Promise<BordasSubscription> => {
        return this.data(await this.get<BordasSubscription>(`${api}/subscriptions/${subscriptionId}?hostId=${hostId}&state=${state}`));
    };
}

export const bordasSecureService = new BordasSecureService();